import { z } from 'zod';
import { retrievalStatusZodEnum } from '../../enum';

export const setRetrievalStatusReqDto = z.object({
  status: retrievalStatusZodEnum(),
});
export type SetRetrievalStatusReqDto = z.infer<typeof setRetrievalStatusReqDto>;
